import React from 'react';
import './Drawcanvas.css';
import NewGame from './NewGame';
import Player from './Player';

function GameOverLose(props) {
    return (
      <div className={props.display + " absolute GameOverLose bg-white shadow-2xl w-2/3 md:w-1/4 shadow-lg sm:p-5 text-base text-gray-700 text-xl grid place-content-center fakerWon rounded"}>
        <p>The fake artist, <Player player={props.faker} />, has remained hidden and won!</p>
        <p className='pb-8'>The secret art subject was {props.secret}</p>
        <NewGame socket={props.socket}/>
      </div>
    );
  
}

export default GameOverLose;
